module.exports = __webpack_public_path__ + "img/HEP_NAVIO_tc.ad0f7542.jpg";